import packageJson from "@wff/package.json";
import { environmentSelector } from "@wff/store/environmentSlice";
import { useAppSelector } from "@wff/store/hooks";

const AppVersion = () => {
  const { localDevOrQaDomain } = useAppSelector(environmentSelector);

  return (
    <div
      style={{
        display: localDevOrQaDomain ? "flex" : "block",
        position: localDevOrQaDomain ? "relative" : "absolute",
        left: localDevOrQaDomain ? "0" : "-999em", // when !qaOrDevDomai: completely remove elements from taking up space
        visibility: localDevOrQaDomain ? "visible" : "hidden", // should be in markup for all cases
        height: localDevOrQaDomain ? "32px" : "0",
        width: localDevOrQaDomain ? "100%" : "0",
        alignItems: "center",
        justifyContent: "center",
      }}
      data-testid="app-version-container"
    >
      <p data-testid="app-version-container__number">{`${
        "Version " + packageJson.version
      }`}</p>
    </div>
  );
};

export default AppVersion;
